import React from 'react';

const Divider = () => {
    return (
        <div className="border-t border-gray-300 w-full"></div>
    )
}

export default Divider;